import React from 'react';

/**
 * "· edited" marker shown next to a timestamp when content has been changed
 * since it was posted. Renders nothing when `at` is null, which is the DB's
 * "never edited" state (migration 036) — so it can be dropped in beside any
 * timestamp without a surrounding conditional.
 *
 * The exact time is in the tooltip rather than inline: the fact of an edit is
 * what a reader needs at a glance, and spelling out a second full timestamp
 * next to the first crowds an already dense byline.
 */
const EditedMark = ({ at, className = '' }) => {
  if (!at) return null;
  const when = new Date(at);
  const label = Number.isNaN(when.getTime()) ? 'Edited' : `Edited ${when.toLocaleString()}`;
  return (
    <span className={`flex-shrink-0 ${className}`} style={{ color: 'var(--text-tertiary)' }} title={label}>
      · edited
    </span>
  );
};

export default EditedMark;
